import { NumberField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import { BaseReportingHistoricalTableModel } from '@/data/models/domain/reporting/common/types'

@OrmModel(modelNames.REPORTING_MESSAGE)
export default class ReportingMessage extends BaseReportingHistoricalTableModel {
  @NumberField()
  public deliveryRate: number

  @NumberField()
  public replyRate: number

  @NumberField()
  public sent: number

  @NumberField()
  public received: number

  @NumberField()
  public costs: number
}
